/** file://./../../../../../lsc/NetworkSystem/NetworkData/src/HttpMethods/networkCoverage/reportProcessing/types.ts */
export var ProcessReceptionAreaRequestStatus;
(function (ProcessReceptionAreaRequestStatus) {
    ProcessReceptionAreaRequestStatus[ProcessReceptionAreaRequestStatus["REQUESTED"] = 0] = "REQUESTED";
    ProcessReceptionAreaRequestStatus[ProcessReceptionAreaRequestStatus["PENDING"] = 1] = "PENDING";
    ProcessReceptionAreaRequestStatus[ProcessReceptionAreaRequestStatus["FAILED"] = 2] = "FAILED";
    ProcessReceptionAreaRequestStatus[ProcessReceptionAreaRequestStatus["NO_DATA"] = 3] = "NO_DATA";
    ProcessReceptionAreaRequestStatus[ProcessReceptionAreaRequestStatus["READY"] = 4] = "READY";
})(ProcessReceptionAreaRequestStatus || (ProcessReceptionAreaRequestStatus = {}));
